import {
  Button,
  Card,
  Col,
  Flex,
  Row,
  Typography,
  Image,
  List,
  Rate,
  Tooltip,
} from "antd";
import cat1 from "assets/images/cat1.png";
import "../../product-component/productComponent.scss";

import { CheckCircleOutlined } from "@ant-design/icons";

const EmailFlyer = () => (
  <svg
    className="email-flyer-icon"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.333496 0.548086C0.579534 0.215641 0.970708 0 1.40982 0H8.59053C9.02963 0 9.4208 0.215641 9.66683 0.548082L5.00017 3.99883L0.333496 0.548086Z"
      fill="#A7833F"
    />
    <path
      d="M0 1.33295V6.64337C0 7.38927 0.6126 7.99766 1.36364 7.99766H8.63636C9.38741 7.99766 10 7.38927 10 6.64337V1.33295L5.53468 4.5582C5.21591 4.78843 4.78409 4.78843 4.46532 4.5582L0 1.33295Z"
      fill="#A7833F"
    />
    <circle cx="11" cy="8" r="5" fill="#A7833F" />
    <rect x="8" y="7" width="6" height="2" rx="1" fill="#FFE0A6" />
    <rect
      x="10"
      y="11"
      width="6"
      height="2"
      rx="1"
      transform="rotate(-90 10 11)"
      fill="#FFE0A6"
    />
  </svg>
);

const data = ["Instant Confirmation", "Non Refundable"];

function ProductTileComponent() {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Card className="light-sky-color" size="small">
            <Row className="mb-2" gutter={[16, 16]}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Image
                  height={"100%"}
                  preview={false}
                  width={"100%"}
                  src={cat1}
                />
              </Col>
              <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                <Flex
                  justify={"space-between"}
                  align={"center"}
                  className="h-100"
                  gap={16}
                >
                  <div>
                    <Typography.Title level={5} className="mt-0">
                      Burj Al Arab Restaurants
                    </Typography.Title>
                    <List
                      size="small"
                      bordered={false}
                      dataSource={data}
                      className="product-list"
                      renderItem={(item) => (
                        <List.Item>
                          <CheckCircleOutlined
                            style={{ paddingRight: "10px" }}
                          />
                          {item}
                        </List.Item>
                      )}
                    />
                  </div>
                  <Tooltip title="Add To Email Flyer">
                    <Button
                      type="primary"
                      shape="circle"
                      className="email-flyer"
                      icon={<EmailFlyer />}
                    ></Button>
                  </Tooltip>
                </Flex>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Flex justify={"space-between"} align={"space-between"}>
                  <div>
                    <div className="mb-3">
                      <Button type="link" className="pl-0">
                        <small>About The Experience --</small>
                      </Button>

                      <Button type="link" className="pl-0 py-0">
                        <small>Inclusions</small>
                      </Button>

                      <Button type="link" className="pl-0 py-0">
                        <small>Important Information</small>
                      </Button>
                    </div>
                    <div>
                      <small className="d-block">from AED</small>
                      <Typography.Title level={4} className="mt-0 mb-0">
                        415.00
                      </Typography.Title>
                    </div>
                  </div>
                  <Flex
                    justify={"space-between"}
                    align={"space-between"}
                    vertical
                  >
                    <Flex justify={"center"} align={"end"} vertical>
                      <Rate
                        allowHalf
                        defaultValue={5}
                        className="rate-danger ml-auto"
                      />
                      <small className="d-block mt-1">6 Reviews</small>
                    </Flex>

                    <Flex justify={"end"} align={"end"} vertical>
                      <Button
                        type="primary"
                        size="large"
                        danger
                        className="px-4"
                      >
                        Select
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Card className="light-sky-color" size="small">
            <Row className="mb-2" gutter={[16, 16]}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Image
                  height={"100%"}
                  preview={false}
                  width={"100%"}
                  src={cat1}
                />
              </Col>
              <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                <Flex
                  justify={"space-between"}
                  align={"center"}
                  className="h-100"
                  gap={16}
                >
                  <div>
                    <Typography.Title level={5} className="mt-0">
                      Burj Al Arab Restaurants
                    </Typography.Title>
                    <List
                      size="small"
                      bordered={false}
                      dataSource={data}
                      className="product-list"
                      renderItem={(item) => (
                        <List.Item>
                          <CheckCircleOutlined
                            style={{ paddingRight: "10px" }}
                          />
                          {item}
                        </List.Item>
                      )}
                    />
                  </div>
                  <Tooltip title="Add To Email Flyer">
                    <Button
                      type="primary"
                      shape="circle"
                      className="email-flyer"
                      icon={<EmailFlyer />}
                    ></Button>
                  </Tooltip>
                </Flex>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Flex justify={"space-between"} align={"space-between"}>
                  <div>
                    <div className="mb-3">
                      <Button type="link" className="pl-0">
                        <small>About The Experience --</small>
                      </Button>

                      <Button type="link" className="pl-0 py-0">
                        <small>Inclusions</small>
                      </Button>

                      <Button type="link" className="pl-0 py-0">
                        <small>Important Information</small>
                      </Button>
                    </div>
                    <div>
                      <small className="d-block">from AED</small>
                      <Typography.Title level={4} className="mt-0 mb-0">
                        415.00
                      </Typography.Title>
                    </div>
                  </div>
                  <Flex
                    justify={"space-between"}
                    align={"space-between"}
                    vertical
                  >
                    <Flex justify={"center"} align={"end"} vertical>
                      <Rate
                        allowHalf
                        defaultValue={5}
                        className="rate-danger ml-auto"
                      />
                      <small className="d-block mt-1">6 Reviews</small>
                    </Flex>

                    <Flex justify={"end"} align={"end"} vertical>
                      <Button
                        type="primary"
                        size="large"
                        danger
                        className="px-4"
                      >
                        Select
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default ProductTileComponent;
